var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row px-1 px-md-0 pt-2", attrs: { id: "mentions" } },
    _vm._l(_vm.legalMentions, function (legalMention, index) {
      return _c("div", { key: index, staticClass: "col-12 pb-2" }, [
        _c(
          "button",
          {
            staticClass: "ob1-link-arrow text-start legal-mention-toggle",
            attrs: {
              type: "button",
              "data-bs-toggle": "collapse",
              "aria-expanded": "true",
              id: "mention" + index,
              "data-bs-target": "#collapsed-text" + index,
              "aria-controls": "collapsed-text" + index,
            },
          },
          [_vm._v("\n            " + _vm._s(legalMention.title) + "\n        ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "collapse show font-size-resp-12",
            attrs: {
              id: "collapsed-text" + index,
              "aria-labelledby": "mention" + index,
            },
          },
          [
            _c("div", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html",
                  value: legalMention.text,
                  expression: "legalMention.text",
                },
              ],
            }),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }